import { ReactNode } from "react";
import { cx } from "shared/utils";

type TreeRowSpacing = "compact" | "base" | "card";

const BRANCH_CLASS: Record<TreeRowSpacing, string> = {
  compact: "absolute left-[-20px] top-[10px] w-5 border-t border-content-100",
  base: "absolute left-[-22px] top-3 w-[22px] border-t border-content-100",
  card: "absolute left-[-26px] top-[10px] w-[26px] border-t border-content-100"
};

const TRUNK_CLASS: Record<TreeRowSpacing, string> = {
  compact: "absolute left-[-20px] -top-2 -bottom-2 border-l border-content-100",
  base: "absolute left-[-22px] -top-3 -bottom-3 border-l border-content-100",
  card: "absolute left-[-26px] -top-4 -bottom-4 border-l border-content-100"
};

const TRUNK_LAST_CLASS: Record<TreeRowSpacing, string> = {
  compact: "absolute left-[-20px] -top-2 h-[18px] border-l border-content-100",
  base: "absolute left-[-22px] -top-3 h-6 border-l border-content-100",
  card: "absolute left-[-26px] -top-4 h-[26px] border-l border-content-100"
};

type TreeRowVariant = "solid" | "dashed";

export const TreeRow = ({
  children,
  isLast = false,
  spacing = "compact",
  variant = "solid"
}: {
  children: ReactNode;
  isLast?: boolean;
  spacing?: TreeRowSpacing;
  variant?: TreeRowVariant;
}) => {
  const dashed = variant === "dashed" ? "border-dashed" : "";

  return (
    <div className="relative">
      <span
        aria-hidden
        className={cx(
          isLast ? TRUNK_LAST_CLASS[spacing] : TRUNK_CLASS[spacing],
          dashed
        )}
      />
      <span aria-hidden className={cx(BRANCH_CLASS[spacing], dashed)} />
      {children}
    </div>
  );
};
